import { SettingsLayout } from './SettingsLayout';
import { GeneralSettings } from './GeneralSettings';
import { CustomerIdSettings } from './CustomerIdSettings';
import { BillingSettings } from './BillingSettings';
import { SmtpSettings } from './SmtpSettings';
import { EmailTemplatesPage } from './EmailTemplatesPage';
import { WorkflowTemplates } from './WorkflowTemplates';
import { RolesPermissions } from './RolesPermissions';
import { UsersManagement } from './UsersManagement';
import { PortalSettings } from './PortalSettings';
import { BrandingPage } from './BrandingPage';
import { SystemLookupsPage } from './SystemLookupsPage';
import { DataAuthorizationPage } from './DataAuthorizationPage';
import { FolderTemplatesPage } from './FolderTemplatesPage';

/**
 * SettingsPage — top-level settings page that renders the layout with section routing.
 * Requirements: 15.1, 3.2, 6.1, 8.2, 14.1
 */
export function SettingsPage() {
  return (
    <SettingsLayout>
      {(activeSection) => {
        switch (activeSection) {
          case 'general':
            return <GeneralSettings />;
          case 'customer-id':
            return <CustomerIdSettings />;
          case 'billing':
            return <BillingSettings />;
          case 'smtp':
            return <SmtpSettings />;
          case 'email-templates':
            return <EmailTemplatesPage />;
          case 'workflows':
            return <WorkflowTemplates />;
          case 'roles':
            return <RolesPermissions />;
          case 'users':
            return <UsersManagement />;
          case 'portal':
            return <PortalSettings />;
          case 'branding':
            return <BrandingPage />;
          case 'system-lookups':
            return <SystemLookupsPage />;
          case 'data-authorization':
            return <DataAuthorizationPage />;
          case 'folder-templates':
            return <FolderTemplatesPage />;
          default:
            return <GeneralSettings />;
        }
      }}
    </SettingsLayout>
  );
}
